package org.example.zone360.pages.dashboard.coaches.notifications

import org.example.zone360.models.NotificationsList
import org.example.zone360.models.NotificationsPayload
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Strings
import kotlinx.datetime.*
import org.example.zone360.models.AllReadPayload

fun NotificationsList.toUiModel(): NotificationUiModel {
    val isUnreadForRole = if (AppGlobal.userData.role == Strings.ADMIN) {
        !isAdminRead
    } else {
        !isRead
    }

    return NotificationUiModel(
        id = id,
        senderName = senderName ?: playerName ?: "",
        title = title,
        message = if (AppGlobal.userData.role == Strings.ADMIN) {
            adminMessage ?: message
        } else {
            message
        },
        timeAgo = timeAgoFromTimestamp(timestamp),
        isUnread = isUnreadForRole,
        isAdminRead = isAdminRead,
        showActions = category.startsWith("request"),
        sessionId = sessionId,
        isRead = if (AppGlobal.userData.role == Strings.ADMIN) isAdminRead else isRead,
        receiverId = receiverId,
        category = category,
        senderId = senderId,
        sessionType = sessionType ?: "",
        status = status
    )
}


fun timeAgoFromTimestamp(timestamp: String): String {
    return try {
        val instant = when {
            // Timestamp already has timezone
            timestamp.contains("Z") || timestamp.contains("+") -> {
                Instant.parse(timestamp)
            }

            // Timestamp WITHOUT timezone → treat as LOCAL time
            else -> {
                LocalDateTime.parse(timestamp)
                    .toInstant(TimeZone.currentSystemDefault())
            }
        }

        val now = Clock.System.now()
        val diff = now - instant

        when {
            diff.inWholeSeconds < 60 -> "Just now"
            diff.inWholeMinutes < 60 -> "${diff.inWholeMinutes}m ago"
            diff.inWholeHours < 24 -> "${diff.inWholeHours}h ago"
            diff.inWholeDays < 7 -> "${diff.inWholeDays}d ago"
            else -> "${diff.inWholeDays / 7}w ago"
        }
    } catch (e: Throwable) {
        ""
    }
}


fun buildNotificationsPayload(
    role: String,
    userId: String,
    organization: String,
): NotificationsPayload {
    return when (role) {

        Strings.PLAYER -> NotificationsPayload(
            receiverId = userId,
            organization = organization,
            role = role,
            seasonID = AppGlobal.selectedSeasonId
            )

        Strings.COACH -> NotificationsPayload(
            receiverId = userId,
            organization = organization,
            role = role,
            seasonID = AppGlobal.selectedSeasonId
        )

        Strings.ADMIN -> NotificationsPayload(
            organization = organization,
            seasonID = AppGlobal.selectedSeasonId
        )

        else -> NotificationsPayload(
            organization = organization,
            seasonID = AppGlobal.selectedSeasonId
        )
    }
}

fun buildAllReadPayload(
    role: String,
    userId: String,
    organization: String,
    markAs: String
): AllReadPayload {
    return if (role == Strings.ADMIN) {
        AllReadPayload(
            organization = organization,
            markAs = markAs
        )
    } else {
        AllReadPayload(
            userId = userId,
            organization = organization,
            markAs = markAs
        )
    }
}
